import { render, staticRenderFns } from "./ModelDetail.vue?vue&type=template&id=21d342ac&scoped=true"
import script from "./ModelDetail.vue?vue&type=script&lang=js"
export * from "./ModelDetail.vue?vue&type=script&lang=js"
import style0 from "./ModelDetail.vue?vue&type=style&index=0&id=21d342ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d342ac",
  null
  
)

export default component.exports